import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AcceptDeclineForm } from '../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';
import { SonForm } from '../../../_lib/Form2';

type LatestForumPostsDeleteForm = {
  form: SonForm<any>;
  refresh(): void;
};

export function LatestForumPostsDeleteForm({ form, refresh }: LatestForumPostsDeleteForm) {
  const { t } = useSonTranslation('LatestForumPosts');

  return (
    <AcceptDeclineForm
      form={form as any}
      headline={t('deleteForm.question')}
      onSuccess={refresh}
      messageSuccess={t('deleteForm.status.success')}
      messageSending={t('deleteForm.status.sending')}
      messageFail={t('deleteForm.status.fail')}
    />
  );
}
